import type { AppDispatch } from "app/store";
import { FEATURE_TOGGLE_CONFIG, FeatureToggle } from "config/featureToggles";
import { saveToStorage } from "utils/storage";

import { featureTogglesActions } from "./slice";

/**
 * Dispatches a feature toggle update and, when the toggle has a storage key in
 * FEATURE_TOGGLE_CONFIG, persists the new value automatically.
 */
export const persistFeatureToggle =
    (toggle: FeatureToggle, value: boolean) =>
    (dispatch: AppDispatch): void => {
        dispatch(featureTogglesActions.setFeatureToggle({ toggle, value }));
        const { storageKey } = FEATURE_TOGGLE_CONFIG[toggle];
        if (storageKey !== undefined) {
            saveToStorage(storageKey, String(value));
        }
    };
